module.exports = __webpack_public_path__ + "img/28_60.3f23997b.png";